import { render, staticRenderFns } from "./NavigationTree.vue?vue&type=template&id=cbb511b0&scoped=true"
import script from "./NavigationTree.vue?vue&type=script&lang=js"
export * from "./NavigationTree.vue?vue&type=script&lang=js"
import style0 from "./NavigationTree.vue?vue&type=style&index=0&id=cbb511b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb511b0",
  null
  
)

export default component.exports